import React, { useEffect, useState } from "react";
import CustomCard from "../../styleComp/CustomCard";
import axios from "axios";
import imageURL from '../../images/or.jpg'

const ImageCard = () => {

  return (
    <CustomCard heightCard={"43vh"}>
      <img
        src={imageURL}
        alt="Add"
        style={{ width: "100%", height: "40vh", borderRadius: "20px" }}
      />
    </CustomCard>
  );
};

export default ImageCard;
